exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".marketing-section .text{margin:0;min-width:350px;max-width:650px;padding:2rem;display:flex;align-items:center;flex-direction:column}@media(min-width: 576px){.marketing-section .text{margin:3rem 1rem}}@media(min-width: 768px){.marketing-section .text{display:unset;align-items:unset;flex-direction:unset}}.marketing-section .text h2,.marketing-section .text p{text-align:center}@media(min-width: 768px){.marketing-section .text h2,.marketing-section .text p{text-align:left}}.marketing-section .text h2 .ft-marjeting-h3,.marketing-section .text p .ft-marjeting-h3{font-size:1.5rem;font-weight:500}.marketing-section .text .btn-link{margin-left:-8px;margin-top:-8px}.marketing-section .remove-circle{border-radius:0px !important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/Marketing/Marketing.scss
// module id = 7791
// module chunks = 13